
import { Options, Vue } from "vue-class-component";
import { MutationTypes } from "../store/mutation-types";
import { useStore } from "../store";

@Options({
  props: {
    mainColor: String,
    hoverColor: String,
    text: String,
    padd: String,
    link: String,
    stateMenuNumber: Number,
    stateMenuFilter: String,
    stateMenuMenu: Number,
  },
  computed: {
    btnOptions() {
      const val = this.padd ? this.padd : "6px 25px";
      return {
        "--color": this.mainColor,
        "--hovercolor": this.hoverColor,
        "--padd": val,
      };
    },
  },
  methods: {
    resetMenu() {
      const number = this.stateMenuNumber ? this.stateMenuNumber : 0;
      const filter = this.stateMenuFilter ? this.stateMenuFilter : "";
      const menu = this.stateMenuMenu ? this.stateMenuMenu : 0;
      if (this.text != "billetterie") {
        this.store.commit(MutationTypes.SET_DAY_MENU, {
          number: number,
          filter: filter,
          menu: menu,
        }),
          // clears select
          this.store.commit(MutationTypes.SET_SELECT_FILTERS, {
            programId: "",
            guestType: "",
            tag: "",
          });
      }
    },
    styleButton() {
      // changes style if rounded theme is on, is on mobile, is a billetterie button on mobile
      if (this.$route.path.includes("schedule")) {
        return this.text === "Billetterie" ? "btn tickets home" : "btn home";
      } else {
        return this.text === "Billetterie" ? "btn tickets" : "btn";
      }
    },
  },
})
export default class Button extends Vue {
  text!: string;
  mainColor!: string;
  hoverColor!: string;
  padd!: string;
  link!: string;
  store = useStore();
  stateMenuNumber!: number;
  stateMenuFilter!: string;
  stateMenuMenu!: number;
}
